import script from "./MainSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSidebar.vue?vue&type=script&setup=true&lang=js"

import "./MainSidebar.vue?vue&type=style&index=0&id=c03a080e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c03a080e"]])

export default __exports__